module.exports = __webpack_public_path__ + "img/success-img.6e78283f.png";